module.exports = __webpack_public_path__ + "static/beauty-sima-salon-section-code-65da84a2ba7760e04b26491a1e8c6045.png";